import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 HANA Portfolio. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;